<script setup lang="ts">
import type { DotLoaderProps } from '/#/components/base/loader/dotLoader'

const props = withDefaults(defineProps<DotLoaderProps>(), { size: 'xs', color: 'slate' })

/**
 * @name appearance
 * @description Holds dot-loader's appearance classes.
 */
const appearance = computed(() => [props.size, props.color])
</script>

<template>
  <div class="dot-loader" :class="appearance">
    <span />
    <span />
    <span />
    <span />
  </div>
</template>
